import { types } from 'mobx-state-tree'
import { ConvertableDate } from 'store/types/date'

export const Tournament = types.model('Tournament', {
  id: types.identifierNumber,
  tournamentName: types.string,
  sportType: types.string,
  logo: types.maybeNull(types.string),
  marketingPromotion: types.optional(types.boolean, false),
  startTime: types.maybeNull(ConvertableDate),
  endTime: types.maybeNull(ConvertableDate),
  venue: types.maybeNull(types.string),
  website: types.maybeNull(types.string),
  city: types.maybeNull(types.string),
  country: types.maybeNull(types.string),
})
